import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';
import { CLOSE_MODAL_ICON } from 'assets/icons';
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background-color: #f7f2f0;
  /* The modal is rendered inside the top bar (TopBar / MobileChrome), whose peach text colour would
     otherwise reach any text here that doesn't set its own — the empty table's "No data" did. */
  color: ${UiColors.forestColor};
  border-radius: 8px;
  max-width: 90%;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media ${DEVICES.laptopL} {
    max-width: 95%;
  }
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${UiColors.forestColor};
`;

export const ModalCloseButton = styled.button`
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  cursor: pointer;
  background: transparent url(${CLOSE_MODAL_ICON}) no-repeat center center;
`;

export const ModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`;

export const ChangesCount = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 16px;
  font-weight: 500;
`;

export const NoChangesText = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
  font-size: 16px;
`;

// New styled components for user info card
export const InfoCard = styled.div`
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: ${UiColors.forestColor};
  font-size: 14px;
  min-width: 100px;
  margin-right: 24px;
`;

export const InfoValue = styled.span`
  color: ${UiColors.forestColor};
  font-size: 16px;
  min-width: 0;
  overflow-wrap: break-word;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${UiColors.forestColor};
  margin: 0;
  flex: 1;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SearchInput = styled.input`
  padding: 4px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 13px;
  color: #374151;
  outline: none;
  width: 180px;
  background: white;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: ${UiColors.forestColor};
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const TableWrapper = styled.div`
  min-height: 60px;
  max-height: 340px;
  overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  margin-bottom: 20px;
`;

export const TableHeader = styled.thead`
  background-color: #f9fafb;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  background: ${({ isHighlighted }) => (isHighlighted ? '#fef9c3' : 'white')};
  &:not(:last-child) {
    border-bottom: 1px solid #e5e7eb;
  }

  ${TableBody} &:hover {
    background-color: ${({ isHighlighted }) => (isHighlighted ? '#fef08a' : '#f9fafb')};
  }
`;

export const TableHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  width: 50%;
  color: ${UiColors.forestColor};
  border-bottom: 2px solid #e5e7eb;

  &:not(:last-child) {
    border-right: 1px solid #e5e7eb;
  }
`;

export const TableSubHeaderCell = styled.th`
  padding: 10px 16px;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
  color: #374151;
  background-color: #f3f4f6;

  &:not(:last-child) {
    border-right: 1px solid #e5e7eb;
  }
`;

export const TableCell = styled.td`
  padding: 12px 16px;
  font-size: 13px;
  color: #374151;
  word-break: break-word;
  max-width: 300px;

  &:not(:last-child) {
    border-right: 1px solid #e5e7eb;
  }

  ${({ isUpdated }) =>
    isUpdated &&
    `
    background-color: #fef3c7;
    font-weight: 500;
    color: #92400e;
  `}
`;

export const ModalFooter = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;

  button {
    width: 150px;
  }
`;

export const FieldLabel = styled.div`
  color: #6b7280;
`;

export const FieldName = styled.div`
  font-weight: 500;
  color: ${UiColors.forestColor};
  margin-top: 2px;
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-top: 24px;
  transition: background-color 0.2s ease;
  gap: 12px;

  @media ${DEVICES.mobileXL} {
    flex-direction: column;
    align-items: start;
  }

  &:hover {
    background-color: #f3f4f6;
  }

  &:first-of-type {
    margin-top: 0;
  }
`;

export const ExpandIcon = styled.span`
  position: relative;
  width: 30px;
  color: #6b7280;
  font-size: 12px;
  transition: transform 0.2s ease;
`;

export const InfoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;

  @media ${DEVICES.tablet} {
    padding: 0;
    padding-right: 20px;
  }
  :hover {
    cursor: pointer;
  }
`;

/* The empty state's cell: spans every column, without TableCell's 300px cap or padding, so the message
   centres in the full table width. */
export const EmptyCell = styled.td`
  padding: 0;
`;

export const NoDataWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 200px;
  justify-content: center;
  align-items: center;
  background-color: white;
`;
